import { media, spacing } from '@gyym/ui'
import styled, { css } from 'styled-components'

import { HEADER_HEIGHT } from '../BaseLayout'

const RIGHT_COL_WIDTH = 564 as const

export const Container = styled.div`
  display: flex;
  flex-grow: 1;
  margin: 0 auto;
  width: 100%;
  gap: ${spacing(10)};
`

export const LeftColumn = styled.div`
  width: ${({ theme }) => theme.breakpoints.pcValue - RIGHT_COL_WIDTH}px;
  flex-grow: 1;
  display: none;

  ${media.pc} {
    display: block;
  }
`

export const RightColumn = styled.div<{ tabletFullscreen: boolean }>`
  width: 100%;
  flex-grow: 1;

  ${media.pc} {
    max-width: ${RIGHT_COL_WIDTH}px;
  }

  ${({ tabletFullscreen }) =>
    tabletFullscreen &&
    css`
      padding: 0;
      position: absolute;
      top: ${HEADER_HEIGHT}px;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 10;

      ${media.pc} {
        position: relative;
        top: initial;
        bottom: initial;
        left: initial;
        right: initial;
      }
    `}
`
